var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"contact-content"},[_c('Particles',{attrs:{"routeName":_vm.$route.name}}),_vm._v(" "),_c('keep-alive',[_c(_vm.currentIndex,{tag:"component",attrs:{"formData":_vm.formData},on:{"currentIndexHandler":_vm.currentIndexHandler}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7405594b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/School/School.vue
// module id = null
// module chunks = 